import {
  faDiagramSubtask,
  faFile,
  faFileAudio,
  faImage,
  faLink,
  faVideo,
  faAddressCard,
  faNewspaper,
  faCircleQuestion,
} from "@fortawesome/pro-regular-svg-icons";

export const favouriteResourceTypes = [
  { key: 1, name: "assets", icon: faDiagramSubtask },
  { key: 2, name: "documents", icon: faFile },
  { key: 3, name: "images", icon: faImage },
  { key: 4, name: "videos", icon: faVideo },
  { key: 5, name: "audios", icon: faFileAudio },
  { key: 6, name: "contacts", icon: faAddressCard },
  { key: 7, name: "text", icon: faLink },
  { key: 8, name: "news", icon: faNewspaper },
  { key: 9, name: "help", icon: faCircleQuestion },
];
